<div class="extrato-importacao container-fluid">
  <h3><Strong>Extrato de Importação</Strong></h3>
  <mat-card>
    <mat-card-header class="header-padrao">
      <mat-card-title>
        <form class="d-flex align-items-center filtros-header" [formGroup]="filterForm">
          <mat-form-field>
            <mat-label>Buscar pelo período de:</mat-label>
            <input matInput
              autocomplete="off"
              maskDate [matDatepicker]="dataInicio"
              (dateChange)="paging.index = 0; selecionarExtratoImportacao()"
              formControlName="fromDate">
            <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
            <mat-datepicker #dataInicio></mat-datepicker>
          </mat-form-field>
          <mat-form-field>
            <mat-label>até:</mat-label>
            <input matInput
              autocomplete="off"
              maskDate [matDatepicker]="dataFim"
              (dateChange)="paging.index = 0; selecionarExtratoImportacao()"
              formControlName="toDate">
            <mat-datepicker-toggle matSuffix [for]="dataFim"></mat-datepicker-toggle>
            <mat-datepicker #dataFim></mat-datepicker>
          </mat-form-field>
            <button mat-icon-button (click)="paging.index = 0; clearFields()" matTooltip="Limpar Campos">
              <i class="fas fa-eraser eraser-button"></i>
            </button>
        </form>
      </mat-card-title>
    </mat-card-header>
    <mat-progress-bar [hidden]="!isLoading" color="primary" mode="indeterminate"></mat-progress-bar>
    <mat-card-content class="no-padding">
      <div [hidden]="isLoading || imports?.data?.length === 0">
        <div>
          <table mat-table [dataSource]="imports" matSort>

            <ng-container matColumnDef="criacao">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Data Processamento </th>
              <td mat-cell *matCellDef="let imports"> {{ imports.dataCriacao | date: 'dd/MM/yyyy' }} </td>
            </ng-container>

            <ng-container matColumnDef="arquivo">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Nome do Arquivo </th>
              <td mat-cell *matCellDef="let imports"> {{ imports.arquivo }} </td>
            </ng-container>

            <ng-container matColumnDef="loteID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Lote </th>
              <td mat-cell *matCellDef="let imports"> {{ imports.loteID }} </td>
            </ng-container>

            <ng-container matColumnDef="statusImportacao">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Status Importação </th>
              <td mat-cell *matCellDef="let imports"> {{ imports.statusImportacao }} </td>
            </ng-container>

            <ng-container matColumnDef="totalLogico">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Total Lógico </th>
              <td mat-cell *matCellDef="let imports"> {{ imports.totalLogico }} </td>
            </ng-container>

            <ng-container matColumnDef="totalFisico">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Total Físico </th>
              <td mat-cell *matCellDef="let imports"> {{ imports.totalFisico }} </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
              <td mat-cell *matCellDef="let imports"> {{ imports.status }} </td>
            </ng-container>

            <ng-container matColumnDef="acao">
              <th mat-header-cell *matHeaderCellDef> Ação </th>
              <td mat-cell *matCellDef="let imports">
                <button mat-flat-button
                style="width: 80px"
                [color]="imports.statusImportacao == 'Falha' ? 'warn' : 'primary'"
                (click)="imports.statusImportacao == 'Falha' ? openImportErrors(imports.loteID) : openImportDetails(imports.loteID)">
                  {{ imports.statusImportacao == 'Falha' ? 'Abrir' : 'Detalhe' }}
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
        <app-paginacao [pageIndex]="paging?.index"
          [pageSize]="paging?.size"
          [length]="paging?.length"
          (page)="onPageChange($event)"
          [pageSizeOptions]="[10,20,50]"></app-paginacao>
      </div>
      <div *ngIf="!isLoading && imports?.data?.length === 0" class="d-flex justify-content-center align-items-center" style="height: 100px;">
        Nenhum registro para o período!
      </div>
    </mat-card-content>
  </mat-card>
</div>
